import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Route, Switch } from 'react-router-dom';
import MenuToggler from '../Menu/Toggler.jsx';
import EditorToggler from '../Helpers/EditorToggler.jsx';
import isActive from '../../utils/isActive';
import ChatButton from '../Chat/ChatButton';
import { inject, observer } from 'mobx-react'

class GeneralWrapper extends Component {
  constructor(props) {
    super(props);
    this.state={
      show_shadow:false,
      options_mode:'general',
    };

    this._onScroll=(e)=>{
      const scrollTop=e.target.scrollingElement.scrollTop;
      if(scrollTop && !this.state.show_shadow) {
        this.setState({ show_shadow:true });
      }
      if(!scrollTop && this.state.show_shadow) {
        this.setState({ show_shadow:false });
      }
    };

  }
  getMenu() {
    const l=this.props.translateStore.t.menu;
    const t=this.props.translateStore.t;
    let menu={
      anime:[
        {to:'/anime/my/',title:l.animelist, enabled:this.props.meStore.me.data.id },
        {to:'/anime/',title:l.database, enabled:true, regexp:'^/anime(?!/my).*$' },
      ],
      blog:[
        {to:'/blog/my',title:l.blog, enabled:this.props.meStore.me.data.id },
        {to:'/blog/',title:l.blogspot, enabled:true, regexp:'^/blog(?!/my|/draft|/edit).*$' },
        {to:'/blog/drafts',title:this.props.translateStore.t.blog.drafts, enabled:this.props.meStore.me.data.id },
        {to:'/blog/edit',title:this.props.translateStore.t.blog.compose_blog, enabled:this.props.meStore.me.data.id },
      ],
      spying:[
        {to:'/spying/all/',title: t.lk.type_all, enabled: this.props.meStore.me.data.id },
        {to:'/spying/blog/',title: t.lk.type_blog, enabled: this.props.meStore.me.data.id },
        {to:'/spying/figurines/',title: t.lk.type_figure, enabled: this.props.meStore.me.data.id },
        {to:'/spying/photos/',title: t.lk.type_photo, enabled: this.props.meStore.me.data.id },
        {to:'/spying/anime/',title: t.lk.type_anime, enabled: this.props.meStore.me.data.id },
        {to:'/spying/characters/',title: t.lk.type_character, enabled: this.props.meStore.me.data.id },
        {to:'/spying/news/',title: t.lk.type_news, enabled: this.props.meStore.me.data.id },
      ],
      last_comments:[
        {to:'/last_comments/my/',title:"Для вас", enabled: this.props.meStore.me.data.id },
        {to:'/last_comments/spy/',title:"Слежка за контентом", enabled: this.props.meStore.me.data.id },
        {to:'/last_comments/follow/',title:"Слежка за пользователями", enabled: this.props.meStore.me.data.id },
        {to:'/last_comments/your/',title:"Ваши", enabled: this.props.meStore.me.data.id },
        {to:'/last_comments/all/',title:"Все", enabled: true },
      ],
      characters:[
        {to:'/characters/',title:l.database, enabled:true },
      ],
      figures:[
        {to:'/figures/my/',title:l.shelf185, enabled:this.props.meStore.me.data.id },
        {to:'/figures/wishlist/',title:this.props.translateStore.t.myshelf.WISH_LIST, enabled:this.props.meStore.me.data.id },
        {to:'/figures/preorder/',title:this.props.translateStore.t.myshelf.BOX_PREORDER, enabled:this.props.meStore.me.data.id },
        {to:'/figures/',title:l.database, enabled:true, regexp:'^/figures(?!/my|/wishlist|/preorder|/add).*$' },
        {to:'/figures/add/',title:l.add_figure, enabled:this.props.meStore.me.data.id },
      ],
      photospot:[
        {to:'/photospot/my/',title:l.photos, enabled:this.props.meStore.me.data.id, regexp:'^/photospot/my(?!/albums).*$' },
        {to:'/photospot/my/albums',title:this.props.translateStore.t.myphotos.ALBUMS, enabled:this.props.meStore.me.data.id },
        {to:'/photospot/',title:l.photospot, enabled:true, regexp:'^/photospot(?!/my).*$' },
      ],
      market:[
        {to:'/market/',title:this.props.translateStore.t.evaMarket.market, enabled:true, regexp:'^/market(?!/store|/orders|/myorders|/favourites).*$' },
        {to:'/market/favourites/',title:this.props.translateStore.t.evaMarket.favourites, enabled:this.props.meStore.me.data.id },
        {to:'/market/orders/',title:this.props.translateStore.t.evaMarket.orders_in_your_store, enabled:this.props.meStore.me.data.id },
        {to:'/market/store/',title:this.props.translateStore.t.evaMarket.my_store, enabled:this.props.meStore.me.data.id },
        {to:'/market/myorders/',title:this.props.translateStore.t.evaMarket.my_orders, enabled:this.props.meStore.me.data.id },
      ],
      shelf:[
        {to:'/shelf/',title:this.props.translateStore.t.user.USERS_TITLE, enabled:true, regexp:'^/shelf(?!/me/following|/me/followed).*$' },
        {to:'/shelf/me/following/',title:this.props.translateStore.t.user.FOLLOW, enabled:this.props.meStore.me.data.id },
        {to:'/shelf/me/followed/',title:this.props.translateStore.t.user.FOLLOWERS, enabled:this.props.meStore.me.data.id },
      ],
      profile:[
        {to:'/profile/',title:this.props.translateStore.t.user.REQ, enabled:this.props.meStore.me.data.id, regexp:'^/profile(?!/settings|/other|/additional).*$' },
        {to:'/profile/settings/',title:this.props.translateStore.t.user.ACC_SETT, enabled:this.props.meStore.me.data.id },
        {to:'/profile/other/',title:this.props.translateStore.t.user.OTH, enabled:this.props.meStore.me.data.id },
        {to:'/profile/additional/',title:this.props.translateStore.t.user.ADD_FIELDS, enabled:this.props.meStore.me.data.id },
      ],
      chat:[
        {to:'/chat/',title:this.props.translateStore.t.evaPrivateChat.all_chats, enabled:this.props.meStore.me.data.id, regexp:'^/chat(?!/settings|/other|/additional).*$' },
      ],
      moderation:[
        {to:'/moderation/figures/',title:"Figures", enabled:this.props.meStore.me.data.id },
      ]
    };
    if(this.props.menuType === 'chat') {
      if(this.props.chatStore.main_window.chat) {
        let chatName=this.props.chatStore.main_window.chat.name;
        if(chatName==='one_on_one') {
          const notYou=this.props.chatStore.main_window.items.find((item)=>{ return this.props.chatStore.main_window.you.id!=item.id });
          chatName=notYou.user_table_nick;
        }
        menu.chat[0].regexp=`^/chat(?!/${this.props.chatStore.main_window.chat.id}).*$`;
        menu.chat.push(
          {
            to: `/chat/${this.props.chatStore.main_window.chat.id}`,
            title: chatName,
            enabled: this.props.meStore.me.data.id,
          }
        );
      }
    }
    const cur=menu[this.props.menuType];
    if(cur) {
      const innerMenu=cur.map((item)=>{
        if(item.enabled) {
          return (
            <Link key={item.to} className={`dib topMenuHeight topMenuLineHeight topMenuItem vat hpadd10 ${isActive(this.props.router,item.to,item.regexp)?'bg-w2 selectedTopMenu':''}`} to={item.to}>
              {item.title}
            </Link>
          )
        }
      });
      return innerMenu;
    }

    return null;
  }
  componentWillUnmoun() {
    window.removeEventListener('scroll', this._onScroll);
    window.removeEventListener('resize', this._onResize);
  }
  componentDidMount() {
    window.addEventListener('scroll', this._onScroll);
    window.addEventListener('resize', this._onResize);
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.props.grid_mode == 's') {
      if (this.props.meStore.me.datanuType == 'chat' && this.props.chatStore.main_window.chat) {
        if (this.state.options_mode !== 'chat') {
          this.setState({options_mode: 'chat', show_shadow: true});
        }
      } else {
        if (this.state.options_mode !== 'general') {
          this.setState({options_mode: 'general'});
        }
      }
    } else {
      if (this.state.options_mode !== 'general') {
        this.setState({options_mode: 'general'});
      }
    }
  }

  render() {
    return (
      <div>
        <div className="topMenuHeight">

        </div>
        <div className={`pf topMenuLine pa-tl w100 bg-w1 sideMenuPadding ${this.state.show_shadow?'boxShadow':''}`} style={{zIndex:10}}>
          <div className={`topMenuHeight up12 margin `}>
            <MenuToggler />

            <div className="cell s-auto">
              <div className="mw100 ofa wsnw">
                {this.getMenu()}
              </div>
            </div>
            {this.state.options_mode==='general'?(
              <div className="cell s-middle s-shrink tar">
                <ChatButton />
                <EditorToggler />
              </div>
            ):null}
            {this.state.options_mode==='chat' && this.props.chatStore.main_window.chat?(
              <div className="cell s-middle s-shrink tar m-dn">

                {this.props.chatStore.main_window.chat.name !== 'one_on_one'?(
                  <div className={`dib tac menuSquare pointer `} onClick={()=>{  this.props.chatStore.main_window.showGroupsEditor(); }}>
                    <div className="up12 splice h100">
                      <div className="cell s-middle s-auto">
                        <i className="mdi mdi-account-multiple fs30 "></i>
                      </div>
                    </div>
                  </div>
                ):null}

                <div className={`dib tac menuSquare pointer `} onClick={()=>{  this.props.chatStore.main_window.showOptions(); }}>
                  <div className="up12 splice h100">
                    <div className="cell s-middle s-auto">
                      <i className="mdi mdi-settings fs30 "></i>
                    </div>
                  </div>
                </div>

              </div>
            ):null}
          </div>
        </div>
        <div>
          {this.props.children}
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    me:state.me,
    router:state.router,
    t:state.translate,
    chat_main_window:state.chat_main_window,
    grid_mode:state.grid_mode
  }
}

// export default connect(mapStateToProps)(GeneralWrapper);
export default inject("translateStore","router","meStore","appStateStore","chatStore")(observer(GeneralWrapper));
